import { useQuery } from '@tanstack/react-query';
import giftClient from '../../../api/gift';

const preloadCategoryImages = (categories: { categoryImageUrl: string }[]) => {
  categories.forEach((category) => {
    const img = new Image();
    img.src = category.categoryImageUrl;
  });
};

const useGiftCategories = () => {
  return useQuery({
    queryKey: ['gift-categories'],
    queryFn: async () => {
      const categories = await giftClient.listCategories();
      preloadCategoryImages(categories);
      return categories;
    },
    refetchOnWindowFocus: false,
  });
};

export default useGiftCategories;
